// Invoice constants for the Eazy Fatoora application

// Default VAT rate
export const DEFAULT_VAT_RATE = 15;

// Invoice statuses
export const INVOICE_STATUSES = {
  DRAFT: 'Draft',
  PENDING: 'Pending',
  COMPLETED: 'Completed',
  CANCELLED: 'Cancelled'
};

// Payment statuses
export const PAYMENT_STATUSES = {
  NOT_PAID: 'Not Paid',
  PARTIALLY_PAID: 'Partially Paid',
  PENDING: 'Pending',
  PAID: 'Paid'
};

// Payment methods
export const PAYMENT_METHODS = {
  CASH: 'Cash',
  BANK_TRANSFER: 'Bank Transfer',
  CREDIT_CARD: 'Credit Card',
  CHEQUE: 'Cheque'
};

// Customer types
export const CUSTOMER_TYPES = {
  B2B: 'B2B',
  B2C: 'B2C'
};

// Default terms and conditions
export const DEFAULT_TERMS = 'Payment due within 30 days. Late payments subject to 2% monthly interest.';

// Default new item template
export const DEFAULT_NEW_ITEM = {
  product: null,
  description: '',
  quantity: 1,
  price: 0,
  vatRate: DEFAULT_VAT_RATE,
  discount: 0
};

// Column visibility defaults
export const DEFAULT_VISIBLE_COLUMNS = {
  description: false,
  discountPerc: false,
  discountAmt: false,
  netValue: false,
  priceWithVat: true,
  vatAmount: true,
  grandTotal: true
};

// Sample data for demonstration (to be removed in production)
export const SAMPLE_CUSTOMERS = [
  { id: 0, name: 'Walk In Customer', vatNumber: 'N/A', email: 'N/A' },
  { id: 1, name: 'Abdullah Trading Co.', vatNumber: '310175397400003', email: 'info@abdullahtc.com' },
  { id: 2, name: 'Saudi Technical Industries', vatNumber: '310554324800001', email: 'accounts@stisa.com' },
  { id: 3, name: 'Al-Riyadh Enterprises', vatNumber: '300893276100003', email: 'billing@alriyadh.com' },
];

export const SAMPLE_PRODUCTS = [
  { id: 1, name: 'Office Desk', description: 'Standard office desk 120x80cm', price: 1200, vat: 15 },
  { id: 2, name: 'Executive Chair', description: 'Ergonomic leather chair', price: 850, vat: 15 },
  { id: 3, name: 'Filing Cabinet', description: '4-drawer metal cabinet', price: 650, vat: 15 },
  { id: 4, name: 'Desktop Computer', description: 'i7 processor, 16GB RAM, 512GB SSD', price: 3500, vat: 15 },
  { id: 5, name: 'Conference Table', description: 'Large oval conference table', price: 4200, vat: 15 },
];

export const SAMPLE_AGENTS = [
  { id: 1, name: 'Mohammed Al-Salem' },
  { id: 2, name: 'Sarah Abdullah' },
  { id: 3, name: 'Faisal Al-Otaibi' },
];

// Style constants
export const CONTROL_STYLE = {
  '& .MuiOutlinedInput-root': {
    borderRadius: 0,
    height: 36,
  },
  '& .MuiInputBase-input': {
    py: 0.75,
    fontSize: '0.875rem'
  },
  '& .MuiInputLabel-root': {
    fontSize: '0.875rem'
  },
  '& .MuiSelect-select': {
    py: 0.75
  }
};

export const MULTILINE_STYLE = {
  ...CONTROL_STYLE,
  '& .MuiOutlinedInput-root': {
    borderRadius: 0,
    minHeight: 36,
  }
};

// Column width constants
export const NUMERICAL_COLUMN_WIDTH = '80px';
export const AMOUNT_COLUMN_WIDTH = '90px';

// Table styles
export const TABLE_CONTAINER_STYLE = {
  mb: 0.5, 
  border: 'none',
  boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
  borderRadius: '4px',
  overflow: 'hidden',
  '& .MuiTable-root': {
    borderCollapse: 'separate',
    borderSpacing: 0,
  },
  '& .MuiTableHead-root': {
    backgroundColor: '#f9fafc',
    '& .MuiTableRow-root': {
      '& .MuiTableCell-root': {
        fontWeight: 600,
        color: '#455a64',
        borderBottom: '2px solid #e0e0e0',
        whiteSpace: 'nowrap',
        padding: '10px 12px',
      }
    }
  },
  '& .MuiTableBody-root': {
    '& .MuiTableRow-root': {
      transition: 'background-color 0.2s ease',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.02)'
      }
    }
  },
  '& .MuiTableCell-root': {
    border: '1px solid rgba(224, 224, 224, 0.4)',
    padding: '8px 12px',
    fontSize: '0.8125rem',
    height: 32,
    '&:first-of-type': {
      borderLeft: '1px solid rgba(0, 0, 0, 0.12)',
    },
    '&:last-child': {
      borderRight: '1px solid rgba(0, 0, 0, 0.12)',
    },
  },
  '& .MuiTableHead-root .MuiTableCell-root': {
    backgroundColor: '#f8faff',
    fontWeight: 600,
    fontSize: '0.8125rem',
    padding: '4px 8px',
    height: 32,
    borderBottom: '2px solid rgba(0, 0, 0, 0.12)',
  },
  '& .MuiTableBody-root .MuiTableRow-root:last-child .MuiTableCell-root': {
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
  },
  // Align input fields with form styling
  '& .MuiInputBase-root': {
    fontSize: '0.8125rem',
  },
  '& .MuiInputBase-input': {
    padding: '2px 0',
  },
  '& .MuiAutocomplete-root .MuiInputBase-root': {
    fontSize: '0.8125rem',
  }
};
